class Validate {
 numeric() {
    return  /^[0-9۰-۹]*$/
 }

 fileSize() {

 }

 fileMime() {

 }
}

export default new Validate()
